/* qeslint-disable */
// q@ts-nocheck

export function setBounds(element: HTMLElement, x: number, y: number, w: number, h: number): void {
    element.style.left = `${x}px`;
    element.style.top = `${y}px`;
    element.style.width = `${w}px`;
    element.style.height = `${h}px`;
}
